const FooterViewModel = () => {
  const getInTouchWithUsDetail = [
    { title: "Phone: ", detail: "02-092-6777" },
    {
      title: "",
      detail:
        "Unicity Marketing (Thailand) Co.,Ltd. 44/1 Ground floor & 15 floor, Rungrojthanakul Building, Ratchadapisek Road, Huaykwang, Bangkok 10310",
    },
    {
      title: "Monday-Saturday: ",
      detail: "10 AM - 10 PM",
      title2: "Sunday: ",
      detail2: "Closed",
    },
    {
      title: "",
      detail: "cs_thailand@unicity.com",
    },
  ];
  const quickLinks = [
    { title: "Shopping", link: "" },
    { title: "Enroll", link: "" },
    { title: "Download", link: "" },
    { title: "WFDSA Member  & Join us", link: "" },
  ];

  const help = [
    { title: "New Password & Register", link: "" },
    { title: "Report for price dumping", link: "" },
    { title: "Register BIOS LIFE AIR warranty", link: "" },
    { title: "Terms & Conditions", link: "" },
    { title: "Privacy Policy", link: "" },
  ];

  return {
    getInTouchWithUsDetail,
    quickLinks,
    help,
  };
};

export default FooterViewModel;
